<template>
  <div class="gui-flex gui-flex-rows">
    <v-dialog
      v-model="dialogSale"
      persistent
      max-width="550px"
      transition="dialog-transition"
      v-if="dialogSale"
    >
    <v-card class="no__padding">
      <v-card-title>
        <h2>Sleva objednávky</h2>
      </v-card-title>
      <v-card-text class="pt-0 pb-2">
        <v-layout row wrap align-end>
          <v-flex xs12>
            <v-text-field
              label="Zadejte slevu na 1 ks"
              suffix="Kč"
              class="mx-2"
              type="number"
              v-model="polozkaCena.sleva"
              @input="(e) => { var sleva = polozkaCena.sleva != null && polozkaCena.sleva.length > 0 ? parseFloat(polozkaCena.sleva) : 0; polozkaCena.cena_po_sleve = parseFloat(polozkaCena.prodejni_cena) - sleva; }"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <p class="mx-2">Max. sleva <strong>{{polozkaCena.max_sleva | formatMoney}} {{polozkaCena.mena.zkratka}}</strong></p>
            <p class="mx-2">Bude odečteno <strong v-html="computeDiscountCredits(polozkaCena)"></strong> kr.</p>
            <p class="mx-2">Cena po slevě za 1 ks: <strong>{{polozkaCena.cena_po_sleve | formatMoney}} {{polozkaCena.mena.zkratka}}</strong></p>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary elevation-0" dark @click="ulozitSlevu"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
        <v-btn color="grey elevation-0 lighten-3" @click="dialogSale=false">Zavřít</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRemove"
      persistent
      max-width="500px"
      transition="dialog-transition"
      v-if="dialogRemove"
    >
      <v-card class="pa-0">
        <v-card-text class="pa-0 pt-5">
          <p class="text-center subheading">Opravdu chcete smazat objednávku <strong>{{ dItem.variabilni_symbol }}</strong> ?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="remove" :loading="sending">Smazat objednávku</v-btn>
          <v-btn color="grey" flat @click="dialogRemove=false;" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCreate"
      persistent
      max-width="1200px"
      transition="dialog-transition"
      v-if="dialogCreate"
    >
    <v-card class="no__padding">
      <v-card-title>
        <h2 v-if="!editMode">Vytvořit novou objednávku</h2>
        <h2 v-else>Upravit objednávku</h2>
      </v-card-title>
      <v-card-text class="pt-0 pb-2" :class="{'pl-0 pr-0': $vuetify.breakpoint.smAndDown}">
        <v-form ref="createForm" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <datetimepicker v-model="newItem.datum_sjednani" class="mx-3 d-flex" label="Datum objednávky"></datetimepicker>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Variabilní symbol objednávky"
                    class="mt-4 pt-0 mx-3"
                    v-model="newItem.variabilni_symbol"
                    :disabled="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm3>
              <meny v-model="newItem.mena_id" class="mt-2 mx-2" @changed="(e) => { newItem.mena = e; }" :disabled="editMode"></meny>
            </v-flex>
            <v-flex xs12 sm3>
              <zpusoby-doruceni v-model="newItem.zpusob_doruceni" class="mt-2 mx-2" :rules="rulesRequired" @changed="(e) => { postovne_vyber = e.postovne; computeTotal(); }"></zpusoby-doruceni>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-2 mb-2">
            <v-flex xs12 sm6>
              <h4 class="mx-3">Fakturační adresa:</h4>
              <vyber-adresy v-model="newItem.fakturacni_adresa" :client="id" class="mt-2" label="Vybrat adresu" :rules="true" :fakturacni="true" :selectFirst="true"></vyber-adresy>
            </v-flex>
            <v-flex xs12 sm6>
              <h4 class="mx-3" :class="{'mt-2': $vuetify.breakpoint.smAndDown}">Dodací adresa:</h4>
              <vyber-adresy v-model="newItem.dodaci_adresa" :client="id" class="mt-2" label="Vybrat adresu" :dorucovaci="true" :selectFirst="true"></vyber-adresy>
            </v-flex>
          </v-layout>
          <v-card color="grey lighten-4 mx-3 mt-4">
            <h4 class="mx-0">Produkty v objednávce:</h4>
            <v-data-table
              :headers="newHeaders"
              :items="newItems"
              :pagination.sync="pagination"
              :total-items="pagination.totalItems"
              :rows-per-page-items="[25, 50, 100, 200]"
              class="mt-2"
            >
              <template slot="items" slot-scope="props">
                <tr v-if="props.item.produkt != null">
                  <td>
                    <router-link v-if="!props.item.postovne" :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</router-link>
                    <span v-else>Poštovné</span>
                    <div v-if="props.item.fixni_castka"><span class="red--text caption mt-1 bold">Fixní cena</span></div>
                  </td>
                  <td class="text-xs-right">
                    <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id">
                      <v-text-field
                        v-model="cena.prodejni_cena"
                        :suffix="cena.mena.zkratka"
                        type="number"
                        @input="(e) => {  cena.cena_po_sleve = parseFloat(cena.prodejni_cena) - cena.sleva; computePartials(props.item.produkt, cena); props.item.fixni_castka = true; computeTotal(); }"
                      ></v-text-field>
                    </p>
                  </td>
                  <td>
                    <v-text-field
                      type="number"
                      class="mt-3 pt-0"
                      v-model="props.item.produkt.kredity_jednorazovy_nakup"
                      reverse
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      type="number"
                      class="mt-3 pt-0"
                      v-model="props.item.pocet"
                      reverse
                      :rules="rulesRequiredMoreThanZero"
                    ></v-text-field>
                  </td>
                  <td class="text-xs-right">
                    <p v-for="(cena, n) in props.item.ceny" class="text-xs-right mt-3" xs4 :key="'produkt-' + props.item.produkt.id.toString() + '-prodejni-cena-' + n.toString()" v-if="cena.mena.id==newItem.mena_id">
                      <span v-html="computePrice(cena.cena_po_sleve, props.item.pocet)" v-if="!preneseni_dan_povinnosti"></span>
                      <span v-html="computePrice(cena.prodejni_cena_bez_dph - (cena.sleva != null ? parseFloat(cena.sleva) : 0), props.item.pocet)" v-if="preneseni_dan_povinnosti"></span>&nbsp;{{cena.mena.zkratka}}
                    </p>
                  </td>
                  <td>
                    <v-layout row>
                      <v-flex>
                        <v-btn color="primary lighten-1" depressed class="mr-2 mt-2" @click="(e) => { slevaClick(props.item); }">Sleva</v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn color="grey lighten-3" depressed fab small @click="newItems.splice(newItems.indexOf(props.item), 1);computeTotal();"><v-icon>delete</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <tr>
                  <td><span>Poštovné:</span></td>
                  <td colspan="5" class="text-xs-right">
                    <span v-if="postovne!=null">{{postovne.cena | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span></span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr>
                  <td>Celkem bez DPH:</td>
                  <td colspan="5" class="text-xs-right">
                    {{newItemCelkem.bez_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                  </td>
                </tr>
                <tr v-if="newItemCelkem.dph_10>0">
                  <td>DPH 10%</td>
                  <td colspan="5" class="text-xs-right">
                    {{newItemCelkem.dph_10 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                  </td>
                </tr>
                <tr v-if="newItemCelkem.dph_15>0">
                  <td>DPH 15%</td>
                  <td colspan="5" class="text-xs-right">
                    {{newItemCelkem.dph_15 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                  </td>
                </tr>
                <tr v-if="newItemCelkem.dph_21>0">
                  <td>DPH 21%</td>
                  <td colspan="5" class="text-xs-right">
                    {{newItemCelkem.dph_21 | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Celkem s DPH:</strong></td>
                  <td colspan="5" class="text-xs-right">
                    <strong>{{newItemCelkem.s_dph | formatMoney}} <span v-if="newItem.mena!=null">{{newItem.mena.zkratka}}</span></strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <productsearch label="Vyhledat produkt" class="mt-3" @changed="productChanged" :clearOnSelect="true"></productsearch>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          <v-card color="grey lighten-4 mx-3 mt-4">
            <v-textarea
              class="mx-3"
              label="Poznámka k objednávce"
              height="60"
              v-model="newItem.poznamka"
            ></v-textarea>
          </v-card>
          <div class="pa-3 pl-4 red--text" v-if="preneseni_dan_povinnost_invalid_1">
            Souhrn částky produktů stříbra bez zvláštního režimu DPH musí být menší než 95 000 Kč.
          </div>
          <div class="pa-3 pl-4 red--text" v-if="preneseni_dan_povinnost_invalid_2">
            Souhrn částky produktů stříbra bez zvláštního režimu DPH musí být menší než 95 000 Kč.
          </div>
          <div class="pa-3 pl-4 red--text" v-if="preneseni_dan_povinnosti">
            Objednávka podléhá přenesení daňové povinnosti.
          </div>
          <div class="pa-3 pl-4 red--text" v-if="error_text != null">
            {{error_text}}
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-3 elevation-0" dark @click="create" v-if="!editMode" :loading="sending">Vytvořit</v-btn>
        <v-btn color="blue darken-3 elevation-0" dark @click="edit" v-else :loading="sending">Upravit</v-btn>
        <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="1200px"
      transition="dialog-transition"
      v-if="dialogDetail"
    >
    <v-card flat class="no__padding">
      <v-card-title v-if="!loadingDetail">
        <h2>Objednávka č. {{detailItem.cislo_nakupu}}</h2>
      </v-card-title>
      <v-card-text>
        <div v-if="loadingDetail" class="pa-5">
          <Loader :loading="true" skin="light"></Loader>
        </div>
        <div v-else>
          <v-card class="grey lighten-4" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  Datum: <strong>{{detailItem.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6>
                  Variabilní symbol: <strong>{{detailItem.variabilni_symbol}}</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-4">
                <v-flex xs12 sm6>
                  Stav: <strong>{{detailItem.stav_objednavky.nazev}}</strong>
                </v-flex>
                <v-flex xs12 sm6>
                  Doručení: <strong v-if="detailItem.zpusob_doruceni!=null">{{detailItem.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card class="grey lighten-4 mt-3" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <h3>Fakturační adresa:</h3>
                  <adresa-view :adresa="detailItem.fa_adresa" class="mt-2"></adresa-view>
                </v-flex>
                <v-flex xs12 sm6>
                  <h3>Doručovací adresa:</h3>
                  <adresa-view :adresa="detailItem.dod_adresa" class="mt-2"></adresa-view>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card color="grey lighten-4 mt-3" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndDown}">
            <h4 class="mx-0">Produkty v objednávce:</h4>
            <v-data-table
              :headers="detailProductsHeaders"
              :items="detailItem.polozky"
              :pagination.sync="pagination"
              :total-items="pagination.totalItems"
              :rows-per-page-items="[25, 50, 100, 200]"
              class="mt-2"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    <router-link v-if="!props.item.postovne" :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</router-link>
                    <span v-else>Poštovné</span>
                    <div v-if="props.item.fixni_castka"><span class="red--text caption mt-1 bold">Fixní cena</span></div>
                  </td>
                  <td class="text-xs-right">
                    {{props.item.castka_mj | formatMoney}} {{props.item.mena.zkratka}}
                  </td>
                  <td class="text-xs-right">
                    <span v-if="props.item.sleva>0">{{props.item.sleva | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                  <td class="text-xs-right">
                    {{props.item.mnozstvi}} ks
                  </td>
                  <td class="text-xs-right">
                    <span v-if="props.item.castka_dph_10>0">{{props.item.castka_dph_10 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else-if="props.item.castka_dph_15>0">{{props.item.castka_dph_15 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else-if="props.item.castka_dph_21>0">{{props.item.castka_dph_21 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else>0 {{props.item.mena.zkratka}}</span>
                  </td>
                  <td class="text-xs-right">
                    <span v-html="computePrice(props.item.castka_mj - props.item.sleva, props.item.mnozstvi)" v-if="!preneseni_dan_povinnosti"></span>
                    <span v-html="computePrice(props.item.castka_bez_dph - props.item.sleva, props.item.mnozstvi)" v-if="preneseni_dan_povinnosti"></span>&nbsp;{{props.item.mena.zkratka}}
                  </td>
                  <td class="text-xs-right">
                    {{props.item.kredity | formatDouble}} kr.
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <tr>
                  <td>Celkem bez DPH:</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_bez_dph | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_10>0">
                  <td>DPH 10%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_10 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_15>0">
                  <td>DPH 15%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_15 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_21>0">
                  <td>DPH 21%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_21 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Celkem s DPH:</strong></td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError"><strong>{{detailItem.castka_celkem | formatMoney}} {{detailItem.mena.zkratka}}</strong></span>
                    <span v-else>--</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions class="pb-3">
        <a :href="api_url + 'osoby/' + $props.id + '/jednorazove-nakupy/' + detailItem.id + '/pdf'" target="_blank"><v-btn color="primary" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF objednávku</v-btn></a>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="editClick(detailItem)"><v-icon>edit</v-icon> Upravit objednávku</v-btn>
        <v-btn color="grey" flat @click="dialogDetail=false">Zavřít</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

    <div class="custom-scrollbar">
      <v-flex xs12 sm4 class="pt-4 pr-2 pl-2" :class="{'pl-4 pr-4': $vuetify.breakpoint.smAndUp}">
        <v-btn color="blue darken-3" @click="createClick" class="ma-0 mb-4" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline>
          <v-icon class="mr-2">add</v-icon>
          Vytvořit objednávku
        </v-btn>
      </v-flex>
      <div class="table-border__radius pb-4 pr-2 pl-2" :class="{'pl-4 pr-4': $vuetify.breakpoint.smAndUp}">
        <v-data-table
          :loading="loadingTable"
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.datum | formatDate }}</td>
            <td class="text-xs-right">{{ props.item.variabilni_symbol }}</td>
            <td class="text-xs-right">{{ props.item.castka_celkem | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td class="text-xs-right">{{ props.item.castka_celkem_fixace | formatMoney }} {{props.item.mena.zkratka}}</td>
            <td>{{props.item.stav_objednavky.nazev}}</td>
            <td class="text-xs-center">
              <a :href="api_url + 'faktury/' + props.item.fa_id + '/pdf'" target="_blank" v-if="props.item.fa_pdf==1">
                <v-btn color="primary" depressed><v-icon>cloud_download</v-icon></v-btn>
              </a>
            </td>
            <td class="text-right">
              <!--<router-link :to="{ path: '/jednorazove-nakupy-detail/'+props.item.id }"><v-btn color="primary" class="elevation-0">Detail</v-btn></router-link>-->
              <v-layout row>
                <v-flex shrink>
                  <v-btn color="primary" @click="openDetail(props.item.id)" class="elevation-0"><v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                </v-flex>
                <v-flex shrink v-if="props.item.stav_objednavky.stav=='nova'">
                  <v-btn color="red" flat @click="removeClick(props.item)" class="elevation-0"><v-icon small class="mr-2">delete</v-icon> Smazat</v-btn>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      dialogCreate: false,
      dialogSale: false,
      newHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena MJ", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Kredity MJ", value: "kredity_jednorazovy_nakup", sortable: false, width: 150, align: "right" },
        { text: "Počet", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "", value: "", sortable: false, width: 60, align: "right" },
      ],
      detailProductsHeaders: [
        { text: "Produkt", value: "produkt", sortable: false },
        { text: "Cena/ks", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Sleva/ks", value: "id", sortable: false, width: 150, align: "right" },
        { text: "Počet ks", value: "pocet", sortable: false, width: 150, align: "right" },
        { text: "DPH celkem", value: "id", sortable: false, width: 150, align: "right" },
        { text: "Cena celkem s DPH", value: "ceny", sortable: false, width: 150, align: "right" },
        { text: "Kredity MJ", value: "kredity", sortable: false, width: 150, align: "right" },
      ],
      newItems: [],
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Číslo obj. (VS)', value: 'variabilni_symbol', align: "right" },
        { text: 'Částka obj.', value: 'castka_celkem', align: "right" },
        { text: 'Částka fixace', value: 'castka_celkem_fixace', align: "right", sortable: false },
        { text: 'Stav', value: 'stav_objednavky', sortable: false },
        { text: 'Faktura', value: 'faktura', sortable: false, align: 'center' },
        { text: '', value: null, sortable: false, align: 'right' }
      ],
      items: [],
      newItem: null,
      newItemCelkem: { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 },
      updating: false,
      sending: false,
      dialogInit: {
        zpusob_doruceni: null,
        mena_id: null,
        dodaci_adresa: null,
        fakturacni_adresa: null,
        poznamka: null,
        variabilni_symbol: null
      },
      valid: false,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      rulesRequiredMoreThanZero: [
        (v) => !!v && v > 0 || "Pole je vyžadováno"
      ],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      dialogDetail: false,
      loadingDetail: false,
      detailItem: null,
      computingError: false,
      polozka: null,
      polozkaCena: null,
      editMode: false,
      preneseni_dan_povinnost_invalid_1: false,
      preneseni_dan_povinnost_invalid_2: false,
      dialogRemove: false,
      dItem: null,
      postovne_vyber: [],
      postovne: null,
      error_text: null,
      preneseni_dan_povinnosti: false
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  mounted: function() {
    this.load();
  },
  props: {
    id: [ String, Number ]
  },
  watch: {
    newItem: {
      deep: true,
      handler (v) {
        this.computeTotal();
      }
    },
    newItems: {
      deep: true,
      handler (v) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        this.computeTotal();
      }
    }
  },
  methods: {
    computeTotal () {

      this.preneseni_dan_povinnosti = false;

      if (this.newItems != null && this.newItems.length > 0) {

        var mena_id = this.newItem.mena_id;
        this.newItemCelkem.bez_dph = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].prodejni_cena_bez_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_10 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 10 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_15 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 15 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.dph_21 = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].sazba_dph == 21 ? (pc[0].prodejni_cena_dph * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0)) : 0; }).reduce((a, b) => { return a + b; });
        this.newItemCelkem.s_dph = this.newItems.map((e) => { var pc = e.ceny.filter((c) => { return c.mena.id == mena_id; }); return pc[0].cena_po_sleve * (e.pocet.length > 0 && parseInt(e.pocet) > 0 ? parseInt(e.pocet) : 0); }).reduce((a, b) => { return a + b; });
        console.log(this.computingError);

        var bez_dph = false;

        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
            bez_dph = true;
            this.preneseni_dan_povinnosti = true;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }
        if (this.newItem.fakturacni_adresa.dic == null || this.newItem.fakturacni_adresa.dic.length == 0) {
          this.preneseni_dan_povinnost_invalid_1 = false;
          this.preneseni_dan_povinnost_invalid_2 = false;
          this.preneseni_dan_povinnosti = false;
          bez_dph = false;
        }

        if (bez_dph) {
          this.newItemCelkem.dph_10 = 0;
          this.newItemCelkem.dph_15 = 0;
          this.newItemCelkem.dph_21 = 0;
          this.newItemCelkem.s_dph = this.newItemCelkem.bez_dph;
        }

        var celkem_s_dph = this.newItemCelkem.s_dph;
        this.postovne = this.postovne_vyber.filterOne((e) => { return e.mena_id = mena_id && e.cena_objednavky_od <= celkem_s_dph && e.cena_objednavky_do >= celkem_s_dph });
        if (this.postovne != null) {
          this.newItemCelkem.bez_dph += this.postovne.cena_bez_dph;
          this.newItemCelkem.dph_21 += this.postovne.cena - this.postovne.cena_bez_dph;
          this.newItemCelkem.s_dph += this.postovne.cena;
        }

      }
      else {
        this.newItemCelkem = { bez_dph: 0, s_dph: 0, dph_10: 0, dph_15: 0, dph_21: 0 };
      }
    },
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("osoby/"+this.$props.id+"/jednorazove-nakupy/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.newItem.datum_sjednani = parseInt(new Date().getTime() / 1000);
      this.dialogCreate = true;
      this.editMode = false;
      this.newItems = [];
      this.postovne = null;
      this.postovne_vyber = null;
      window.API.get("osoby/"+this.$props.id+"/jednorazove-nakupy/vs-dalsi").then(function(body) {
        this.newItem.variabilni_symbol = body.vs;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
      window.API.get("osoby/"+this.$props.id+"/jednorazove-nakupy/nastaveni").then(function(body) {
        this.newItem.zpusob_doruceni = body.zpusob_doruceni;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }
        if (this.newItem.fakturacni_adresa.dic == null || this.newItem.fakturacni_adresa.dic.length == 0) {
          this.preneseni_dan_povinnost_invalid_1 = false;
          this.preneseni_dan_povinnost_invalid_2 = false;
        }
        this.error_text = null;
        if (!this.preneseni_dan_povinnost_invalid_1 && !this.preneseni_dan_povinnost_invalid_2) {
          this.sending = true;
          var mena_id = this.newItem.mena_id;
          window.API.post("osoby/" + this.$props.id + "/jednorazove-nakupy", {
            datum: this.newItem.datum_sjednani,
            mena_id: this.newItem.mena_id,
            zpusob_doruceni: this.newItem.zpusob_doruceni,
            fa_adresa: this.newItem.fakturacni_adresa,
            dod_adresa: this.newItem.dodaci_adresa,
            variabilni_symbol: this.newItem.variabilni_symbol,
            poznamka: this.newItem.poznamka,
            produkty: this.newItems.map((e) => {
              return {
                id: e.produkt.id,
                mnozstvi: e.pocet,
                cena: e.ceny.filterOne((i) => {
                  return i.mena.id == mena_id;
                }),
                kredity: parseFloat(e.produkt.kredity_jednorazovy_nakup),
                fixni_castka: e.fixni_castka
              };
            }),
            postovne: this.postovne != null ? this.postovne.id : null
          }).then(function(body) {
            if (body.inserted) {
              this.load();
              this.dialogCreate = false;
            }
            else if (body.vs_exists) {
              this.error_text = "Variabilní symbol objednávky již existuje."
            }
            this.sending = false;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.sending = false;
          }.bind(this));
        }
      }
    },
    productChanged (e) {
      if (e != null)
        window.API.get("produkty/" + e.id + "/ceny").then(function(body) {
          body.forEach((e) => {
            e.cena_po_sleve = parseFloat(e.prodejni_cena);
            e.sleva = null;
          });
          this.newItems.push({ produkt: e, produkt_id: e.id, pocet: "1", ceny: body, fixni_castka: false });
          this.computeTotal();
        }.bind(this)).catch(function(err) {
        }.bind(this));
    },
    computePrice(c, q) {
      if (c == null || q == null || c <= 0 || q <= 0)
        return 0;
      return window.th.formatPrice(c*q, 2, ",", " ").replace(" ", "&nbsp;")
    },
    openDetail (v) {
      this.loadingDetail = true;
      this.dialogDetail = true;
      window.API.get("osoby/"+this.$props.id+"/jednorazove-nakupy/" + v).then(function(body) {
        if (typeof body.error == "undefined") {
          this.detailItem = body;
        }
        else {
          // @TODO error show
        }
        this.loadingDetail = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    computePartials (p, c) {
      switch (p.zvlastni_rezim) {
        case "neni":
          var dph = parseFloat(c.cena_po_sleve) - (parseFloat(c.cena_po_sleve) / (1 + c.sazba_dph / 100));
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_90":
          var dph = parseFloat(c.cena_po_sleve) >= c.nakladova_cena ? (parseFloat(c.cena_po_sleve) - c.nakladova_cena - ((parseFloat(c.cena_po_sleve) - c.nakladova_cena) / (1 + c.sazba_dph / 100))) : 0;
          c.prodejni_cena_dph = dph;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve) - dph;
          break;
        case "par_92":
          c.prodejni_cena_dph = 0;
          c.prodejni_cena_bez_dph = parseFloat(c.cena_po_sleve);
          break;
      }
      this.computeTotal();
    },
    slevaClick (polozka) {
      this.polozka = polozka;
      var mena_id = this.newItem.mena_id;
      this.polozkaCena = window.th.copy(this.polozka.ceny.filterOne((e) => { return e.mena.id == mena_id; }));
      this.dialogSale = true;
    },
    ulozitSlevu () {
      var mena_id = this.newItem.mena_id;
      var f = this.polozka.ceny.filter((e) => { return e.mena.id == mena_id  });
      var i = this.polozka.ceny.indexOf(f[0]);
      this.polozka.ceny[i].sleva = this.polozkaCena.sleva;
      this.polozka.ceny[i].cena_po_sleve = parseFloat(this.polozkaCena.prodejni_cena) - this.polozkaCena.sleva;
      this.polozka.ceny[i].prodejni_cena_dph = parseFloat(this.polozkaCena.prodejni_cena_dph);
      this.computePartials(this.polozka.produkt, this.polozka.ceny[i]);
      this.polozka.produkt.kredity_jednorazovy_nakup = Math.max(this.polozka.produkt.kredity_jednorazovy_nakup_vychozi - this.computeDiscountCredits(this.polozka.ceny[i]), 0).toString().replace(",", ".");
      this.dialogSale = false;
    },
    editClick (v) {
      this.newItem = {};
      this.newItem.id = this.detailItem.id;
      this.newItem.datum_sjednani = this.detailItem.datum;
      this.newItem.variabilni_symbol = this.detailItem.variabilni_symbol;
      this.newItem.datum = this.detailItem.datum;
      this.newItem.mena_id = this.detailItem.mena.id;
      this.newItem.zpusob_doruceni = this.detailItem.zpusob_doruceni.id;
      this.newItem.fakturacni_adresa = this.detailItem.fa_adresa;
      this.newItem.dodaci_adresa = this.detailItem.dod_adresa;
      this.newItem.poznamka = this.detailItem.poznamka;
      this.newItems = this.detailItem.polozky.filter((e) => { return !e.postovne; }).map((e) => {

        var produkt = e.produkt != null ? window.th.copy( e.produkt) : null;
        produkt.kredity_jednorazovy_nakup =  e.kredity.toString();
        produkt.kredity_jednorazovy_nakup_vychozi = e.kredity;

        var sazba_dph = 0;
        if (e.castka_dph_10 > 0)
          sazba_dph = 10;
        else if (e.castka_dph_10 > 0)
          sazba_dph = 10;
        else if (e.castka_dph_15 > 0)
          sazba_dph = 15;
        else if (e.castka_dph_21 > 0)
          sazba_dph = 21;

        return {
          produkt: produkt,
          produkt_id: produkt != null ? produkt.id : null,
          pocet: e.mnozstvi.toString(),
          fixni_castka: e.fixni_castka,
          ceny: [
            {
              mena: e.mena,
              prodejni_cena: (e.castka / e.mnozstvi).toString(),
              prodejni_cena_bez_dph: (e.castka_bez_dph / e.mnozstvi).toString(),
              prodejni_cena_dph: (e.castka - e.castka_bez_dph / e.mnozstvi),
              sleva: e.sleva.toString(),
              cena_po_sleve: (e.castka / e.mnozstvi).toString(),
              sazba_dph: sazba_dph
            }
          ],
        };

      });
      this.dialogDetail = false;
      this.dialogCreate = true;
      this.editMode = true;
    },
    edit () {
      if (this.$refs.createForm.validate()) {
        this.preneseni_dan_povinnost_invalid_1 = false;
        this.preneseni_dan_povinnost_invalid_2 = false;
        var mena_id = this.newItem.mena_id;
        var preneseni_dan_povinnost_castka =  this.newItems.filter((e) => {
          return e.produkt.preneseni_dan_povinnost;
        }).map((e) => { return parseFloat(e.ceny.filterOne((i) => {
          return i.mena.id == mena_id;
        }).prodejni_cena_bez_dph) * parseInt(e.pocet) }).reduce((t, n) => { return t + n; }, 0);
        var polozky_bez_dp = this.newItems.filter((e) => {
          return !e.produkt.preneseni_dan_povinnost;
        }).length;
        if (preneseni_dan_povinnost_castka > 95000) {
          if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp == 0) {
            this.preneseni_dan_povinnost_invalid_2 = false;
          }
          else if (preneseni_dan_povinnost_castka >= 105000 && polozky_bez_dp > 0) {
            this.preneseni_dan_povinnost_invalid_2 = true;
          }
          else {
            this.preneseni_dan_povinnost_invalid_1 = true;
          }
        }
        if (this.newItem.fakturacni_adresa.dic == null || this.newItem.fakturacni_adresa.dic.length == 0) {
          this.preneseni_dan_povinnost_invalid_1 = false;
          this.preneseni_dan_povinnost_invalid_2 = false;
        }
        if (!this.preneseni_dan_povinnost_invalid_1 && !this.preneseni_dan_povinnost_invalid_2) {
          this.sending = true;
          var mena_id = this.newItem.mena_id;
          window.API.put("osoby/" + this.$props.id + "/jednorazove-nakupy/" + this.newItem.id, {
            datum: this.newItem.datum_sjednani,
            zpusob_doruceni: this.newItem.zpusob_doruceni,
            fa_adresa: this.newItem.fakturacni_adresa,
            dod_adresa: this.newItem.dodaci_adresa,
            poznamka: this.newItem.poznamka,
            produkty: this.newItems.map((e) => {
              return {
                row_id: typeof e.id !== "undefined" ? e.id : null,
                id: e.produkt.id,
                mnozstvi: e.pocet,
                cena: e.ceny.filterOne((i) => {
                  return i.mena.id == mena_id;
                }),
                kredity: parseFloat(e.produkt.kredity_jednorazovy_nakup)
              };
            })
          }).then(function(body) {
            if (body.updated) {
              this.load();
              this.dialogDetail = false;
              this.dialogCreate = false;
              this.load();
            }
            this.sending = false;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.sending = false;
          }.bind(this));
        }
      }
    },
    removeClick (v) {
      this.dItem = v;
      this.dialogRemove = true;
    },
    remove () {
      this.sending = true;
      window.API.delete("osoby/"+this.$props.id+"/jednorazove-nakupy/" + this.dItem.id).then(function(body) {
        if (body.deleted) {
          this.load((e) => {
            this.dialogRemove = false;
            this.sending = false;
          });
        }
        else {
          this.sending = false;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    },
    computeDiscountCredits (c) {
      if (!isNaN(c.sleva) &&parseFloat(c.sleva) > 0 && !isNaN(c.sleva_kredity) && parseFloat(c.sleva_kredity) > 0 && !isNaN(c.sleva_kredity_mj) && parseFloat(c.sleva_kredity_mj) > 0) {
        return parseFloat((parseFloat(c.sleva) / parseFloat(c.sleva_kredity_mj) * parseFloat(c.sleva_kredity)).toFixed(2));
      }
      return 0;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/JednorazoveNakupy.vue